
<template>
    <div class="Sidebar">

        <!-- VideoPanel -->
        <VideoSessionPanel class="sb-videoPanel"/>

        <!-- Chat/Paticipants -->
        <md-tabs class="sb-tabs">
            <md-tab id="tab-messages" :md-label="$t('Nachrichten')" exact>
                <ChatTab/>
            </md-tab>
            <md-tab id="tab-participants" :md-label="$t('Teilnehmende') + ' ('+numberOfUsers+')'" to="/components/tabs" exact>
                <ParticipantTab/>
            </md-tab>
        </md-tabs>

        <!-- Button for Minimizing Sidebar - Disabled-->
        <!-- <transition name="fade">
            <md-button class="md-icon-button sb-minimizeButton" v-if="showMinimizeButton" @click="minimizedSidebar = !minimizedSidebar">
                <ArrowCollapseIcon v-if="minimizedSidebar"/>
                <ArrowExpandIcon v-else/>
            </md-button>
        </transition> -->

    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ChatTab from "@/components/flux360/SidebarComponents/ChatTab";
import ParticipantTab from "@/components/flux360/SidebarComponents/ParticipantTab";
import VideoSessionPanel from "@/components/flux360/SidebarComponents/VideoSessionPanel";
// import ArrowCollapseIcon from 'vue-material-design-icons/ArrowCollapse.vue'
// import ArrowExpandIcon from 'vue-material-design-icons/ArrowExpand.vue'

export default {
    components: {ChatTab, ParticipantTab,VideoSessionPanel},
    computed:{
        ...mapGetters(["users"]),
        numberOfUsers(){
            return this.users.length;
        },
    }
}
</script>

<style>
.Sidebar{
    height: 100%;
    overflow: hidden;
}
.sb-videoPanel{
    height: 65%;
}
.sb-tabs{
    height: 35%;
}
.md-tabs-container{
    max-height: 100%;
}
#tab-participants{
    background: #F7F3F3;
}
.md-tabs.md-theme-default .md-tabs-navigation .md-button.md-active{
    color:var(--primaryColor);
}
.md-tabs.md-theme-default .md-tabs-indicator{
    background-color: var(--primaryColor);
}
.md-tabs.md-alignment-left .md-tabs-navigation {
    justify-content: center;
}
.md-tabs-navigation .md-button {
    text-transform: none;
}
.md-tab {
    padding: 0px;
}
.sb-tabs .md-tabs-content {
    overflow: visible;
}
</style>